// ======================================================================
// File Name       : ContentDistributionUsageInfo
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { Col } from 'react-bootstrap';
import { COURSE } from '../../constants/ContentDistributionConstant';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { convertByte } from '../../utils/ServiceRecordUtils';
import SelectBox from '../SelectBox';

const ContentDistributionUsageInfo = ({
  distributionUsage,
  handleSortState,
  handleChange,
  distributionType,
  }) => {
  let userIdCount = '';
  let distributionDrillCount = '';
  let distributionVideoCount = '';
  let distributionDocumentCount = '';
  let distributionLinkCount = '';
  let distributionVideoFlow = '';
  let distributionCourseCount = '';
  if (distributionUsage) {
    if (distributionUsage.distributionUsageInfo) {
      userIdCount = distributionUsage.distributionUsageInfo.userIdCount;
      distributionDrillCount =
      distributionUsage.distributionUsageInfo.distributionDrillCount;
      distributionVideoCount =
      distributionUsage.distributionUsageInfo.distributionVideoCount;
      distributionDocumentCount =
      distributionUsage.distributionUsageInfo.distributionDocumentCount;
      distributionLinkCount = distributionUsage.distributionUsageInfo.distributionLinkCount;
      distributionVideoFlow = distributionUsage.distributionUsageInfo.distributionVideoFlow;
      distributionCourseCount = distributionUsage.distributionUsageInfo.distributionCourseCount;
    }
  }
  return (
    <div>
      <Col sm={12}>
        <Col sm={12} className="margin-top-10">
          <Col sm={3} className="margin-top-10 padding-left-35">
            ■利用ユーザー数
          </Col>
          <Col sm={2} className="margin-top-10">
            {`${userIdCount}人` || ''}
          </Col>
          <Col sm={3} className="margin-top-10">
            ■ビデオ利用流量
          </Col>
          <Col sm={2} className="margin-top-10">
            {!isNaN(distributionVideoFlow) ? convertByte(distributionVideoFlow) : ''}
          </Col>
        </Col>
        <Col sm={12} className="margin-top-10 float-start">
    
          <Col sm={12} className="margin-top-10">
            <Col sm={3} className="margin-top-10 padding-left-35">
            配布種別
            </Col>
            <Col sm={3}>
              <SelectBox
                data={SELECT_BOX_DATA.DISTRIBUTION_OFFER_TYPE}
                name="distributionType"
                onChange={handleChange}
              />
            </Col>
          </Col>
          { distributionType === COURSE &&
            <Col sm={6} className="margin-top-10">
              <Col sm={6} className="margin-top-10 padding-left-35">
                ■利用コース数
              </Col>
              <Col sm={6} className="margin-top-10 float-end">
                {`${distributionCourseCount}` || ''}
              </Col>
            </Col>
          }
          <Col sm={12} className="margin-top-10 padding-left-35">
            ■利用コンテンツ数
          </Col>
          <Col sm={12} className="margin-top-10">
            <Col sm={6} className="margin-top-10 padding-left-35 float-start">
              ドリル
            </Col>
            <Col sm={6} className="margin-top-10 float-end">
              {`${distributionDrillCount}本` || ''}
            </Col>
            <Col sm={6} className="margin-top-10 padding-left-35 float-start">
              ビデオ
            </Col>
            <Col sm={6} className="margin-top-10 float-end">
              {`${distributionVideoCount}本` || ''}
            </Col>
            <Col sm={6} className="margin-top-10 padding-left-35 float-start">
              ドキュメント
            </Col>
            <Col sm={6} className="margin-top-10 float-end">
              {`${distributionDocumentCount}本` || ''}
            </Col>
            <Col sm={6} className="margin-top-10 padding-left-35 float-start">
              リンク
            </Col>
            <Col sm={6} className="margin-top-10 float-end">
              {`${distributionLinkCount}本` || ''}
            </Col>
          </Col>
        </Col>
      </Col>
    </div>
  );
};

export default ContentDistributionUsageInfo;
